/* eslint-disable @next/next/no-img-element */
import { useState, useEffect, useRef } from "react";
import MuxPlayer from "@mux/mux-player-react";

import { apiCheckMuxLiveStatus } from "../../lib/api/video";

function MuxLive({ placeholderUrl, agenda, playbackId, platform }) {
  // In your component:
  const [streamStatus, setStreamStatus] = useState("idle");
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!playbackId) return;

    async function checkStatus() {
      try {
        const result = await apiCheckMuxLiveStatus(playbackId);

        // Stop polling once the stream is active
        if (result.status === "active" && intervalRef.current) {
          setStreamStatus("active");
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      } catch (err) {
        console.error("Failed to check stream status:", err);
      }
    }

    // Check immediately
    checkStatus();

    // Poll every 15 seconds if not active
    intervalRef.current = setInterval(checkStatus, 15000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [playbackId]);

  return streamStatus === "active" ? (
    <MuxPlayer
      streamType="live"
      playbackId={playbackId}
      metadata={{ video_title: agenda?.meetingType }}
      autoPlay
    />
  ) : (
    <div className="relative w-full aspect-video">
      <img
        src={
          placeholderUrl ||
          "https://f004.backblazeb2.com/file/OnAirArchive/LIveStreamNotActive.png"
        }
        className={`w-full h-full ${placeholderUrl ? "object-contain" : "object-cover"}`}
        alt={`${platform?.clientName || "Live stream"} - stream has not started`}
      />
      <p className="absolute bottom-4 left-4 text-white bg-black/60 px-3 py-1 rounded">
        Stream has not started yet
      </p>
    </div>
  );
}

export default MuxLive;
